import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store/store'

import NotFoundView from '@/components/error/404.vue'

import Dashboard from '@/components/view/dashboard/Dashboard'
import WelcomeMessage from '@/components/view/welcomemessage/WelcomeMessage'

import Account from '@/components/view/allbots/Account'
import Template from '@/components/view/template/Template'
import Broadcast from '@/components/view/broadcast/Broadcast'
import Conversation from '@/components/view/intent/Conversation'
import Comment from '@/components/view/intent/CommentToInbox'
import Training from '@/components/view/intent/Training'
import Billing from '@/components/view/billing/Billing'
import Upgrade from '@/components/view/billing/Upgrade'
import RedeemCode from '@/components/view/redeem/redeemcode.vue'
import Ticket from '@/components/view/template/ticket/main.vue'
import SahapanReward from '@/components/view/template/sahapan/main.vue'


import OrderSummaryLine from '@/components/view/template/ecommerce/OrderSummaryLine'
import Chat from '@/components/view/chat/Chat'
import Setup from '@/components/view/getstarted/Setup'
import SetupC2p from '@/components/view/chat2pay/SetupC2p'

import LivechatView from '@/components/view/livechat/LivechatView'
import Live from '@/components/view/live/Main'

import PProfile from '@/components/view/partner/Profile'
import PBlog from '@/components/view/partner/Blog'
import PRedeemCode from '@/components/view/partner/RedeemCode'
import PCustomer from '@/components/view/partner/Customer'

import Swal from 'sweetalert2'

Vue.use(Router)

const allLang = ['en', 'th', 'la']

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('en')
      }
      store.dispatch('setLang', language)

      return next()
    }
  },
  {
    path: '/linenotify',
    // beforeEnter: guardRoute,
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/view/linenotify/Linenotify.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/connect_quality',
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        component: function (resolve) {
          require(['@/components/view/linenotify/Prepare.vue'], resolve)
        }
      }
    ]
  },
  {
    path: '/:lang',
    beforeEnter(to, from, next) {
      let language = to.params.lang
      if (!allLang.includes(language)) {
        return next('en')
      }
      store.dispatch('setLang', language)

      return next()
    },
    component: {
      name: 'lang',
      template: '<router-view></router-view>'
    },
    children: [
      {
        path: '',
        redirect: 'allbots'
      },
      {
        path: 'login',
        name: 'login',
        component: function (resolve) {
          require(['@/components/login/Login.vue'], resolve)
        }
      },
      {
        path: 'nigol',
        name: 'nigol',
        component: function (resolve) {
          require(['@/components/login/Nigol.vue'], resolve)
        }
      },
      {
        path: 'chat2pay',
        name: 'chat2pay',
        component: function (resolve) {
          require(['@/components/login/chat2pay.vue'], resolve)
        },
        meta: {
          title: 'Chat2pay'
        }
      },
      {
        path: 'allbots',
        name: 'allbots',
        component: Account,
        beforeEnter: guardRoute,
        meta: {
          title: 'All Bots'
        }
      },
      {
        path: 'ordersummary',
        name: 'ordersummary',
        component: OrderSummaryLine,
        meta: {
          title: 'Order Summary'
        }
      },
      {
        path: 'chat',
        name: 'chat',
        component: Chat,
        meta: {
          title: 'Chat'
        }
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard,
        beforeEnter: guardRoute,
        meta: {
          title: 'Dashboard'
        }
      },
      {
        path: 'welcome',
        name: 'welcome message',
        component: WelcomeMessage,
        beforeEnter: guardRoute,
        meta: {
          title: 'Welcome Message'
        }
      },
      {
        path: 'conversation',
        name: 'conversation',
        component: Conversation,
        beforeEnter: guardRoute,
        meta: {
          title: 'Conversations'
        }
      },
      {
        path: 'livechat',
        name: 'livechat',
        component: LivechatView,
        beforeEnter: guardRoute,
        meta: {
          title: 'Livechats'
        }
      },
      {
        path: 'broadcast',
        name: 'broadcast',
        component: Broadcast,
        beforeEnter: guardRoute,
        meta: {
          title: 'Broadcast'
        }
      },
      {
        path: 'template',
        name: 'template',
        component: Template,
        beforeEnter: guardRoute,
        meta: {
          title: 'Plugin'
        }
      },
      {
        path: 'ticket',
        name: 'ticket',
        component: Ticket,
        beforeEnter: guardRoute,
        meta: {
          title: 'Ticket'
        }
      },
      {
        path: 'billing',
        name: 'setting',
        component: Billing,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setting'
        }
      },
      {
        path: 'comment',
        name: 'Comment to inbox',
        component: Comment,
        beforeEnter: guardRoute,
        meta: {
          title: 'Reply comment'
        }
      },
      {
        path: 'training',
        name: 'Training',
        component: Training,
        beforeEnter: guardRoute,
        meta: {
          title: 'Training'
        }
      },
      {
        path: 'setup',
        name: 'Setup',
        component: Setup,
        beforeEnter: guardRoute,
        meta: {
          title: 'Get Started'
        }
      },
      {
        path: 'setup_c2p',
        name: 'setup_c2p',
        component: SetupC2p,
        beforeEnter: guardRoute,
        meta: {
          title: 'Setup Chat2Pay'
        }
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: Upgrade,
        beforeEnter: guardRoute,
        meta: {
          title: 'Upgrade package to premium plan'
        }
      },
      {
        path: 'RedeemCode',
        name: 'RedeemCode',
        component: RedeemCode,
        beforeEnter: guardRoute,
        meta: {
          title: 'Redeem Code'
        }
      },
      {
        path: 'live',
        name: 'live',
        component: Live,
        beforeEnter: guardRoute,
        meta: {
          title: 'Live'
        }
      },
      {
        path: 'RewardManager',
        name: 'RewardManager',
        component: SahapanReward,
        beforeEnter: guardRoute,
        meta: {
          title: 'Sahapan Reward'
        }
      },
      {
        path: 'partner',
        component: {
          name: 'partner',
          template: '<router-view></router-view>'
        },
        children: [
          {
            path: '',
            redirect: 'profile'
          },
          {
            path: 'profile',
            name: 'profile',
            component: PProfile,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Profile'
            }
          },
          {
            path: 'blog',
            name: 'blog',
            component: PBlog,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Blog'
            }
          },
          {
            path: 'redeemcode',
            name: 'redeemcode',
            component: PRedeemCode,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Redeem Code'
            }
          },
          {
            path: 'customer',
            name: 'customer',
            component: PCustomer,
            beforeEnter: guardPartnerRoute,
            meta: {
              title: 'Partner Customer'
            }
          }
        ]
      },
      {
        // not found handler
        path: '*',
        component: NotFoundView
      }
    ]
  }
]

const router = new Router({
  routes,
  mode: 'history'
})
router.onError(error => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload()
  }
})
const title = 'ZWIZ.AI Chatbot'
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (['chat2pay', 'setup_c2p'].includes(to.name)) {
    document.title = nearestWithTitle.meta.title
  } else if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ' | ' + title
  } else {
    document.title = title
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el =>
    el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

export default router

function guardRoute(to, from, next) {
  if (to.name == 'dashboard' && to.query && to.query.tab == 'ceemeagain') {
    if (!store.getters.isLoggedIn) {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { tab: 'ceemeagain' }
      })
      return
    }
  }
  var query = { ...to.query }
  query.redirect = to.fullPath

  if (!store.getters.isLoggedIn) {
    if (to.query.usertype == 'nigol') {
      next({
        path: '/' + store.getters.currentLang + '/nigol',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    } else {
      next({
        path: '/' + store.getters.currentLang + '/login',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  } else {
    if (store.state.isFacebook) {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function (response) {
            // checkTokenStatus(next)
            next()
          },
          function (e) {
            next({
              path: '/' + store.getters.currentLang + '/login',
              query: query
            })
          }
        )
      }
      next()
    } else {
      if (store.state.selectedBot) {
        store.dispatch('updateBotDetail').then(
          function (response) {
            // checkTokenStatus(next)
            next()
          },
          function (e) {
            next({
              path: '/' + store.getters.currentLang + '/nigol',
              query: query
            })
          }
        )
      }

      next()
    }
  }
}

function guardPartnerRoute(to, from, next) {
  if (!store.getters.isLoggedIn) {
    next({
      path: '/' + store.getters.currentLang + '/login',
      query: { redirect: to.fullPath, utm_source: to.query.utm_source }
    })
  } else {
    if (store.state.partner_code) {
      next()
    } else {
      next({
        path: '/' + store.getters.currentLang + '/login',
        query: { redirect: to.fullPath, utm_source: to.query.utm_source }
      })
    }
  }
}

function checkTokenStatus(next) {
  var vm = router.app
  if (
    store.state.selectedBot &&
    Object.keys(store.state.selectedBot).length &&
    store.state.selectedBot.hasOwnProperty('statustoken') &&
    !store.state.selectedBot.statustoken
  ) {
    // Swal({
    //   icon: 'error',
    //   width: 650,
    //   allowOutsideClick: false,
    //   confirmButtonColor: '#d33',
    //   title: vm.$t('Hey! Your chatbot has connection error.'),
    //   html: vm.$t('Admin page please log into the zwiz system') + ' <a href="https://cms.zwiz.ai/en/login">(https://cms.zwiz.ai/en/login)</a> ' + vm.$t('again.')
    // }).then(() => {
    //   if (store.getters.isFacebook) {
    //     logout(next)
    //   }
    // })
  }
}

function logout(next) {
  var isFacebook = store.getters.isFacebook
  store.dispatch('logout', null).then()
  if (isFacebook) {
    next({
      path: '/' + store.getters.currentLang + '/login'
    })
  } else {
    next({
      path: '/' + store.getters.currentLang + '/nigol'
    })
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js